import React from 'react';
import { useSelector } from 'react-redux';
import numberToWords from 'number-to-words';
import { selectSubscriptions } from '../../../../../../../selectors/tools';
import { ResultsCancelSubscriptionHeader } from '../../../../../../tools/common/PageLayout.styles';
import { ResultCancelSubscriptionRow, ResultsCancelSubscriptionNameHead } from './ResultText.styles';
import { ResultsStatusColumn } from '../../../../../../tools/SearchPage/SearchResult.styles';

const ResultText = ({ isSearchBothOrdersAndSubscriptions, ordersWithNoParentSubscriptionsPresent }) => {
  const searchSubscription = useSelector(selectSubscriptions);

  const subscriptionVerb = searchSubscription.length > 1 || !searchSubscription.length ? 'are' : 'is';
  const subscriptionNoun =
    searchSubscription.length > 1 || !searchSubscription.length ? 'subscriptions' : 'subscription';
  const ordersNoun =
    ordersWithNoParentSubscriptionsPresent.length > 1 || !ordersWithNoParentSubscriptionsPresent.length
      ? 'orders'
      : 'order';

  return (
    <ResultsCancelSubscriptionHeader hide={!searchSubscription.length}>
      {isSearchBothOrdersAndSubscriptions ? (
        <ResultCancelSubscriptionRow>
          <ResultsCancelSubscriptionNameHead>
            There {subscriptionVerb} {numberToWords.toWords(searchSubscription.length)} {subscriptionNoun} and{' '}
            {numberToWords.toWords(ordersWithNoParentSubscriptionsPresent.length)} {ordersNoun} associated with this
            customer.
          </ResultsCancelSubscriptionNameHead>
        </ResultCancelSubscriptionRow>
      ) : (
        <ResultCancelSubscriptionRow>
          <ResultsCancelSubscriptionNameHead>
            There {subscriptionVerb} {numberToWords.toWords(searchSubscription.length)} {subscriptionNoun} associated
            with this customer.
          </ResultsCancelSubscriptionNameHead>
          <ResultsStatusColumn>Date created</ResultsStatusColumn>
          <ResultsStatusColumn>Status</ResultsStatusColumn>
        </ResultCancelSubscriptionRow>
      )}
    </ResultsCancelSubscriptionHeader>
  );
};

export default ResultText;
